import { render, staticRenderFns } from "./SelecionarPerfil.vue?vue&type=template&id=e94fbd70&scoped=true"
import script from "./SelecionarPerfil.vue?vue&type=script&lang=js"
export * from "./SelecionarPerfil.vue?vue&type=script&lang=js"
import style0 from "./SelecionarPerfil.vue?vue&type=style&index=0&id=e94fbd70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94fbd70",
  null
  
)

export default component.exports